export default __webpack_public_path__ + "static/media/school-tree.3efd955b.png";